import React, { useEffect, useState } from 'react';
import { CURRENT_TCAS_YEAR } from 'constants/school-year';
import cn from 'classnames';
import { callAPI, getRoundState, getRoundDescription, userErrorMessage, showErrorToast } from 'helpers';
import { EMPTY_ROUND } from '../round-data';
import _ from 'lodash';

// Components
import RoundContent from '../RoundContent';
import ModalOfferReplyConsent from './ModalRound2OfferReplyConsent';
import ModalOfferCancelConsent from './ModalRound2OfferCancelConsent';

// Hooks
import { useSelector } from 'react-redux';
import useQuery from 'hooks/useQuery';

const roundType = `2_${CURRENT_TCAS_YEAR}`;
const Round2 = ({ enrollment }) => {
  const profile = useSelector((state) => _.get(state, 'app.user') || {});
  const query = useQuery();

  const [active, setActive] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  const { loading, loadFailed, timestamp } = enrollment;

  // ยืนยันสิทธิ์รอบ 1 ค้างอยู่ (ไม่ได้สละสิทธิ์) = ไม่มีสิทธิ์รอบ 2
  // ตอน alreadyApplied ต้องใช้ slice ว่าง — กัน consent modal เด้งจาก offers รอบ 2 ที่ไม่มีสิทธิ์ใช้แล้ว
  const lastR1 = _.last(_.get(enrollment.byType, [`1_${CURRENT_TCAS_YEAR}`, 'replies']) || []);
  const alreadyApplied = !!(lastR1 && lastR1.enrollment_offer && !lastR1.is_canceled);
  const { offers, replies, offerCount } = (!alreadyApplied && enrollment.byType[roundType]) || EMPTY_ROUND;

  const { flow } = getRoundState({ roundType, timestamp, query });
  const description = loading ? null : getRoundDescription({ roundType, timestamp, offers, replies, alreadyApplied });

  useEffect(() => {
    if (flow === 'default' && !_.get(profile, `consents_accepted_at.offer_reply_2_${CURRENT_TCAS_YEAR}`)) {
      setModalVisible(true);
    } else if (flow === 'cancel' && !_.get(profile, `consents_accepted_at.offer_cancel_2_${CURRENT_TCAS_YEAR}`)) {
      setModalVisible(true);
    }
  }, [flow, profile]);

  const [accepting, setAccepting] = useState(false);
  const _onAcceptConsent = async (consentType) => {
    if (accepting) return;
    try {
      setAccepting(true);
      await callAPI({
        method: 'POST',
        url: '/applicants/me/consents',
        body: {
          consentType,
        },
      });
      setAccepting(false);
    } catch (error) {
      console.error(`Error while trying to accept consent: ${error.message}`);
      showErrorToast(userErrorMessage(error));
      setAccepting(false);
    }
    setModalVisible(false);
  };

  return (
    <div className={cn('r-2', { active })}>
      <header onClick={() => setActive((_active) => !_active)}>
        <b>
          <small>{'รอบ'}</small>2
        </b>
        <h3>
          Quota
          {description && <small>{(description)}</small>}
        </h3>
        <i className="i-down"></i>
      </header>
      <RoundContent
        flow={flow}
        alreadyApplied={alreadyApplied}
        roundType={roundType}
        loading={loading}
        loadFailed={loadFailed}
        offerCount={offerCount}
        offers={offers}
        replies={replies}
        timestamp={timestamp} />
      <ModalOfferReplyConsent
        visible={offers.length && modalVisible && flow === 'default'}
        onSubmit={() => _onAcceptConsent(`offer_reply_2_${CURRENT_TCAS_YEAR}`)}
      />
      <ModalOfferCancelConsent
        visible={offers.length && _.get(_.last(replies), 'program_project') && modalVisible && flow === 'cancel'}
        onSubmit={() => _onAcceptConsent(`offer_cancel_2_${CURRENT_TCAS_YEAR}`)}
      />
    </div>
  );
};

export default Round2;
